import {AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges} from '@angular/core';

@Directive({
  selector: '[appAutoSize]'
})
export class AutoSizeDirective implements OnChanges, AfterViewInit {

  @Input('appAutoSize') value: any;
  private initialHeight?: number;

  constructor(private elementRef: ElementRef) {
  }

  ngAfterViewInit() {
    this.setInitialHeight();
    this.adjust();
  }

  ngOnChanges() {
    this.adjust();
  }

  @HostListener('input')
  onInput() {
    this.adjust();
  }

  adjust(): void {
    const ta = this.elementRef.nativeElement as HTMLTextAreaElement | null;
    if (!ta) {
      return;
    }

    this.setInitialHeight();

    const baseHeight = this.initialHeight ?? ta.offsetHeight;
    ta.style.overflow = 'hidden';
    ta.style.height = `${baseHeight}px`;

    if (!ta.value || ta.value.length === 0) {
      return;
    }

    const expandedHeight = Math.max(baseHeight, ta.scrollHeight);
    ta.style.height = `${expandedHeight}px`;
  }

  private setInitialHeight(): void {
    if (this.initialHeight) {
      return;
    }
    const ta = this.elementRef.nativeElement as HTMLTextAreaElement | null;
    if (!ta) {
      return;
    }

    const computedStyles = window.getComputedStyle(ta);
    const parsedHeight = parseFloat(computedStyles.height);
    const parsedMinHeight = parseFloat(computedStyles.minHeight);

    if (!isNaN(parsedHeight) && parsedHeight > 0) {
      this.initialHeight = parsedHeight;
    } else if (!isNaN(parsedMinHeight) && parsedMinHeight > 0) {
      this.initialHeight = parsedMinHeight;
    } else {
      this.initialHeight = ta.offsetHeight;
    }
  }
}
